module.exports = __webpack_public_path__ + "static/media/slate-ring.31f87681.png";